<template>
  <v-content>
    <v-overlay v-if="loadingOverlay === true">{{loadingOverlayText}}</v-overlay>
    <v-overlay v-if="refreshOverlay === true">
      <div>Fetching Lastest Ads...Reloading in 10 Seconds</div>
    </v-overlay>
    <v-container v-if="candidateData !== null">
      <v-alert :value="displayAlert" :color="alertType">{{alertMsg}}</v-alert>
      <v-row>
<v-flex> <h4 class="subheading grey--text">
        <a
          :href="'/influencer-campaign/manage/'+candidateData.campaign.campaignId"
        >{{candidateData.campaign.campaignName}}</a>
        > @{{candidateData.instagramProfile}}
      </h4></v-flex>
      <v-flex>
        <v-btn :to="'/influencer-campaign/influencer/'+candidateData._id" target="_blank"> Client View </v-btn>
      </v-flex>
      </v-row>
     
      <v-row>
        <v-col cols="12" md="8">
          <v-card>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <div style="padding:10px; text-align:center; ">
                    <img
                      :src="candidateData.fullProfile.profilePic"
                      style="border-radius: 10px; width:75%"
                    />
                  </div>
                </v-col>
                <v-col cols="12" md="8">
                  <v-row>
                    <v-flex md3 class="profile-label p-2">
                      <strong>Profile:</strong>
                    </v-flex>
                    <v-flex md6 class="p-2">
                      <a
                        :href="'https://instagram.com/'+ candidateData.instagramProfile"
                        target="_blank"
                      >https://instagram.com/{{candidateData.instagramProfile}}</a>
                    </v-flex>
                  </v-row>
                  <v-row>
                    <v-flex md3 class="profile-label p-2">
                      <strong>Category:</strong>
                    </v-flex>
                    <v-flex md6 class="p-2">{{candidateData.fullProfile.category}}</v-flex>
                  </v-row>
                  <v-row>
                    <v-flex md3 class="profile-label p-2">
                      <strong>Bio:</strong>
                    </v-flex>
                    <v-flex md6 class="p-2">{{candidateData.fullProfile.bio}}</v-flex>
                  </v-row>
                  <v-row>
                    <v-flex md3 class="profile-label p-2">
                      <strong>Website:</strong>
                    </v-flex>
                    <v-flex md6 class="p-2">
                      <a
                        :href="candidateData.fullProfile.website"
                        target="_blank"
                      >{{candidateData.fullProfile.website}}</a>
                    </v-flex>
                  </v-row>
                  <v-row>
                    <v-flex md3 class="profile-label p-2">
                      <strong>Followers:</strong>
                    </v-flex>
                    <v-flex md6 class="p-2">{{candidateData.fullProfile.followerCount}}</v-flex>
                  </v-row>
                  <v-row>
                    <v-flex md3 class="profile-label p-2">
                      <strong>Following:</strong>
                    </v-flex>
                    <v-flex md6 class="p-2">{{candidateData.fullProfile.followingCount}}</v-flex>
                  </v-row>
                  <v-row>
                    <v-flex md3 class="profile-label p-2">
                      <strong>Posts:</strong>
                    </v-flex>
                    <v-flex md6 class="p-2">{{candidateData.fullProfile.postCount}}</v-flex>
                  </v-row>
                  <v-row>
                    <v-flex md3 class="profile-label p-2">
                      <strong>Engagement Rate:</strong>
                    </v-flex>
                    <v-flex
                      md6
                      class="p-2"
                    >{{ (candidateData.fullProfile.engagementRate * 100).toFixed(2) }}%</v-flex>
                  </v-row>

                  <v-row>
                    <v-flex md3 class="profile-label p-2">
                      <strong>Email:</strong>
                    </v-flex>
                    <v-flex md6 class="p-2">{{ candidateData.fullProfile.email }}</v-flex>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>

          <v-content v-if="candidateData.notes.length > 0">
            <v-card
              v-for="note in candidateData.notes"
              :key="note._id"
              style="margin-top:15px;"
              depressed
            >
              <v-container>
                <v-card-subtitle>
                  <span>{{note.authorName}}</span>&nbsp;
                  <span class="note-date">{{note.dateString}}</span>
                </v-card-subtitle>
                <v-card-text>{{note.text}}</v-card-text>
                <v-card-actions>
                  <v-btn @click="showEditNoteModal(note)" small text color="grey">
                    <v-icon small>fa fa-pen</v-icon>&nbsp; Edit
                  </v-btn>
                  <v-btn @click="showArchiveNoteConfirm(note._id)" small text color="grey">
                    <v-icon small>fa fa-trash</v-icon>&nbsp; Delete
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card>
          </v-content>
        </v-col>
        <v-col cols="12" md="4">
          <v-row style="margin-bottom: 10px;">
            <v-spacer></v-spacer>
            <v-flex class="text-center">
              <v-btn @click="showNoteModal" depressed small color="success">
                <v-icon small>fas fa-plus-circle</v-icon>&nbsp; Add Note
              </v-btn>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex class="text-center">
              <v-btn @click="showArchiveCandidateModal" depressed small color="error">
                <v-icon small>fas fa-trash</v-icon>&nbsp; Archive Influencer
              </v-btn>
            </v-flex>
            <v-spacer></v-spacer>
          </v-row>
          <v-card>
            <v-card-title>
              <v-flex>Influencer Details:</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-right">
                <v-btn class="ma-2" text icon color="gray" @click="editInfluencerDetailsModal=true">
                  <v-icon small>fas fa-user-edit</v-icon>Edit
                </v-btn>
              </v-flex>
            </v-card-title>
            <v-container>
              <v-content>
                <div>
                  <span v-if="influencerFirstName !== null">{{influencerFirstName}}</span>&nbsp;
                  <span v-if="influencerLastName !== null">{{influencerLastName}}</span>
                </div>
                <div v-if="influencerEmail !==null">{{influencerEmail}}</div>
                <div>
                  Address:
                  <div v-if="influencerAddr1">{{influencerAddr1}}</div>
                  <div v-if="influencerAddr2">{{influencerAddr2}}</div>
                  <div v-if="influencerCity">{{influencerCity}}</div>
                  <div>
                    <span v-if="influencerState">{{influencerState}}</span>
                    <span v-if="influencerZip">{{influencerZip}}</span>
                  </div>
                </div>
              </v-content>
            </v-container>
          </v-card>
          <v-card style="margin-top:15px;">
            <v-card-title>Tags:</v-card-title>
            <v-container>
              <tags-input
                element-id="tags"
                v-model="selectedTags"
                :existing-tags="tagList"
                @change="tagSearch"
                @tag-added="tagAdd"
                @tag-removed="tagRemove"
                :typeahead="true"
              ></tags-input>
            </v-container>
          </v-card>
          <v-card style="margin-top:15px;">
            <v-card-title>Status:</v-card-title>
            <v-container>
              <div v-if="candidateData.status =='declined'">Influencer declined participation</div>
              <div v-else-if="candidateData.status =='rejected'">Rejected</div>
              <div v-else-if="candidateData.events.length > 0">
                <v-simple-table>
                  <thead>
                    <tr>
                      <th class="text-left">Action</th>
                      <th class="text-left">Status</th>
                      <th class="text-left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(event, index) in candidateData.events" :key="event._id">
                      <td>{{event.name}}</td>
                      <td>
                        <v-chip x-small label>{{event.status}}</v-chip>
                      </td>

                      <td v-if="index == 0 && event.status=='pending'">
                        <div v-if="event.eventData.type=='select'">
                          <v-btn
                            @click="showEventSelectModal(event)"
                            rounded
                            depressed
                            small
                            outlined
                            color="success"
                          >
                            <v-icon left x-small>fa fa-check</v-icon>COMPLETE
                          </v-btn>
                        </div>
                        <div v-if="event.eventData.type=='confirmation'">
                          <v-btn
                            @click="showEventConfirmModal(event)"
                            rounded
                            depressed
                            small
                            outlined
                            color="success"
                          >
                            <v-icon left x-small>fa fa-check</v-icon>CONFIRM
                          </v-btn>
                        </div>
                        <div v-if="event.eventData.type=='text'">
                          <v-btn
                            @click="showEventSelectModal(event)"
                            rounded
                            depressed
                            small
                            outlined
                            color="success"
                          >
                            <v-icon left x-small>fa fa-check</v-icon>GET ACTION
                          </v-btn>
                        </div>
                      </td>
                      <td v-else-if="index == 0 && event.status=='complete'">{{event.eventInput}}</td>
                      <td
                        v-else-if="event.status=='pending' && candidateData.events[index-1].status=='complete' "
                      >
                        <div v-if="event.eventData.type=='select'">
                          <v-btn
                            @click="showEventSelectModal(event)"
                            rounded
                            depressed
                            small
                            outlined
                            color="success"
                          >
                            <v-icon left x-small>fa fa-check</v-icon>COMPLETE
                          </v-btn>
                        </div>
                        <div v-if="event.eventData.type=='confirmation'">
                          <v-btn
                            @click="showEventConfirmModal(event)"
                            rounded
                            depressed
                            small
                            outlined
                            color="success"
                          >
                            <v-icon left x-small>fa fa-check</v-icon>CONFIRM
                          </v-btn>
                        </div>
                        <div v-if="event.eventData.type=='text'">
                          <v-btn
                            @click="showEventSelectModal(event)"
                            rounded
                            depressed
                            small
                            outlined
                            color="success"
                          >
                            <v-icon left x-small>fa fa-check</v-icon>COMPLETE
                          </v-btn>
                        </div>
                      </td>
                      <td v-else-if="event.status=='complete'">{{event.eventInput}}</td>
                      <td v-else></td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="addNoteModal" max-width="60%">
        <v-card>
          <v-alert :value="noteFormAlert" :color="alertType">{{noteFormAlertMsg}}</v-alert>
          <v-card-title class="headline">Add Note</v-card-title>

          <v-form ref="noteForm" @submit="submitNote">
            <v-card-text>
              <v-col>
                <v-textarea
                  outlined
                  name="newNote"
                  v-model="newNoteText"
                  label="Enter text"
                  value
                  :rules="textCheck"
                ></v-textarea>
                <v-flex md3>
                  <v-select
                    v-model="noteType"
                    :items="noteTypeOptions"
                    label="Note Type"
                    outlined
                    dense
                    :rules="[noteTypeCheck]"
                  ></v-select>
                </v-flex>

                <v-flex md3>
                  <v-select
                    v-model="visibilityType"
                    :items="noteVisiblityOptions"
                    label="Visibility Type"
                    outlined
                    dense
                    :rules="[noteVisibilityCheck]"
                  ></v-select>
                </v-flex>
              </v-col>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="green darken-1" text type="submit">SUBMIT</v-btn>

              <v-btn color="green darken-1" text @click="closeNoteModal">CANCEL</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editNoteModal" max-width="60%">
        <v-card>
          <v-alert :value="noteFormAlert" :color="alertType">{{noteFormAlertMsg}}</v-alert>

          <v-card-title class="headline">Edit Note</v-card-title>

          <v-form ref="editNoteForm" @submit="submitEditNote">
            <v-card-text>
              <v-col>
                <v-textarea
                  outlined
                  name="editNote"
                  v-model="editNoteText"
                  label="Enter text"
                  value
                  :rules="textCheck"
                ></v-textarea>
                <v-flex md3>
                  <v-select
                    v-model="editNoteType"
                    :items="noteTypeOptions"
                    label="Note Type"
                    outlined
                    dense
                    :rules="[noteTypeCheck]"
                  ></v-select>
                </v-flex>

                <v-flex md3>
                  <v-select
                    v-model="editVisibilityType"
                    :items="noteVisiblityOptions"
                    label="Visibility Type"
                    outlined
                    dense
                    :rules="[noteVisibilityCheck]"
                  ></v-select>
                </v-flex>
              </v-col>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="green darken-1" text type="submit">SUBMIT</v-btn>

              <v-btn color="green darken-1" text @click="closeEditNoteModal">CANCEL</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="archiveNoteConfirm" max-width="290">
        <v-card>
          <v-card-title class="headline">Confirm Delete Note?</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="submitArchiveNote()">Yes, Delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="closeArchiveNoteConfirm()">Cancel</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="archiveCandidateModal" max-width="290">
        <v-card>
          <v-card-title class="headline">
            Archive Influencer?
            <br />
            @{{candidateData.instagramProfile}}
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="submitArchiveCandidate()">Yes, Delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="closeArchiveCandidateModal()">Cancel</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editInfluencerDetailsModal" max-width="60%">
        <v-card>
          <v-alert :value="noteFormAlert" :color="alertType">{{noteFormAlertMsg}}</v-alert>

          <v-card-title class="headline">Edit Influencer Details</v-card-title>

          <v-form ref="editDetailsForm" @submit.prevent="submitInfluencerDetails">
            <v-card-text>
              <v-col>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-flex class="justify-center">
                    <v-text-field label="First Name" outlined v-model="influencerFirstName"></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex class="justify-center">
                    <v-text-field label="Last Name" outlined v-model="influencerLastName"></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-row>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-text-field label="Email" outlined v-model="influencerEmail" style="width: 68%"></v-text-field>
                  <v-spacer></v-spacer>
                </v-row>
                <v-row class="justify-center">
                  <v-spacer></v-spacer>
                  <v-flex class="justify-center">
                    <v-text-field label="Address" outlined v-model="influencerAddr1"></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex class="justify-center">
                    <v-text-field label="Address 2" outlined v-model="influencerAddr2"></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-row>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-flex class="justify-center">
                    <v-text-field label="City" outlined v-model="influencerCity" required></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex class="justify-center">
                    <v-text-field label="Zip Code" outlined v-model="influencerZip"></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-row>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-flex class="justify-center">
                    <v-text-field label="State" outlined v-model="influencerState"></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex class="justify-center">
                    <v-text-field label="Country" outlined v-model="influencerCountry"></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" text type="submit">SAVE DETAILS</v-btn>
              <v-btn color="green darken-1" text @click="editInfluencerDetailsModal=false">CANCEL</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="eventSelectModal" max-width="60%">
        <v-card>
          <v-alert :value="noteFormAlert" :color="alertType">{{noteFormAlertMsg}}</v-alert>

          <v-form ref="eventSelectForm" @submit.prevent="processEvent">
            <v-card-text>
              <v-col>
                <h3>{{eventModalLabel}}</h3>
                <v-flex md3>
                  <v-select
                    v-model="eventSelectInput"
                    :items="eventSelectOptions"
                    label="Select:"
                    outlined
                    dense
                  ></v-select>
                </v-flex>
                <v-textarea outlined v-model="eventNote" label="Add Note (optional)" value></v-textarea>
              </v-col>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="green darken-1" text type="submit">SUBMIT</v-btn>

              <v-btn color="green darken-1" text @click="closeEventSelectModal">CANCEL</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="eventConfirmModal" max-width="60%">
        <v-card>
          <v-alert :value="noteFormAlert" :color="alertType">{{noteFormAlertMsg}}</v-alert>

          <v-form ref="eventConfirmForm" @submit.prevent="processEvent">
            <v-card-text>
              <v-col>
                <h3>{{eventModalLabel}}</h3>
                <v-textarea outlined v-model="eventNote" label="Add Note (optional)" value></v-textarea>
              </v-col>
            </v-card-text>
            <v-card-actions>
              <v-btn color="green darken-1" text type="submit">YES</v-btn>

              <v-btn color="green darken-1" text @click="closeEventConfirmModal">NO</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-container>
  </v-content>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import VoerroTagsInput from "@voerro/vue-tagsinput";
import {
  influencerCampaignCandidateReadApi,
  influencerCandidateNoteUpdateApi,
  influencerCandidateNoteCreateApi,
  influencerCandidateNoteArchiveApi,
  influencerCandidateUpdateStatusApi,
  influencerTagSearchApi,
  influencerUpdateApi,
  influencerTagAddApi,
  influencerTagUpdateApi,
  influencerEventUpdateApi,
  influencerCandidateEventsAddApi
} from "@/config/appSettings";
export default {
  components: { "tags-input": VoerroTagsInput },
  data: () => ({
    loadingOverlay: true,
    loadingOverlayText: null,
    refreshOverlay: false,
    addNoteModal: false,
    editNoteModal: false,
    newNoteText: null,
    editNoteText: null,
    editNoteId: null,
    noteType: null,
    editNoteType: null,
    visibilityType: null,
    editVisibilityType: null,
    archiveNoteConfirm: false,
    archiveCandidateModal: false,
    editInfluencerDetailsModal: false,
    archiveNoteId: null,
    lead: null,
    leadAds: [],
    leadImage: null,
    auth: null,
    candidateId: null,
    candidateData: null,
    noteTypeOptions: ["campaign", "global"],
    noteVisiblityOptions: ["team", "team and client"],
    noteFormAlert: false,
    alertType: null,
    displayAlert: false,
    alertMsg: null,
    noteFormAlertMsg: null,
    influencerFirstName: null,
    influencerLastName: null,
    influencerAddr1: null,
    influencerAddr2: null,
    influencerCity: null,
    influencerZip: null,
    influencerState: null,
    influencerCountry: null,
    influencerEmail: null,
    influencerPhone: null,
    tagList: [],
    selectedTags: null,
    tagSearchActive: false,
    eventSelectOptions: null,
    eventNote: null,
    eventTextInput: null,
    eventSelectInput: null,
    eventModalLabel: null,
    eventConfirmModal: false,
    eventSelectModal: false,
    eventTextInputModal: false,
    activeEvent: null,
    textCheck: [
      v => {
        if (v !== null && typeof v !== "undefined") {
          return v.length > 2 || "Please enter more than 3 characters.";
        }
        return "Required";
      }
    ]
  }),
  name: "CandidateDetail",
  methods: {
    async loadCandidate() {
      try {
        this.loadingOverlay = true;
        let candidateDetail = await axios.get(
          `${influencerCampaignCandidateReadApi}/?candidate=${this.$route.params.candidateId}&usertoken=${this.auth}`
        );
        console.log(candidateDetail);
        if (candidateDetail.data.success === true) {
          this.candidateData = candidateDetail.data.result;
          this.loadingOverlay = false;
          if (this.candidateData.events.length > 0) {
            this.eventList = this.candidateData.events;
          }
          if (this.candidateData.events.length < 1) {
            console.log("ADDING CANDIDATE EVENTS:");
            let candidateEventResponse = await axios.post(
              influencerCandidateEventsAddApi,
              {
                usertoken: this.auth,
                candidate: this.$route.params.candidateId
              }
            );
            console.log(
              "HERE ARE THE CANDIDATE EVENT RESPONSE:",
              candidateEventResponse
            );
            this.eventList = candidateEventResponse.data.result;
          }

          // SET EMAIL
          if (
            typeof this.candidateData.influencerDetails.email !== "undefined"
          ) {
            this.influencerEmail = this.candidateData.influencerDetails.email;
          } else if (
            typeof this.candidateData.fullProfile.email !== "undefined"
          ) {
            this.influencerEmail = this.candidateData.fullProfile.email;
          }
          // SET CANDIDATE FORM DETAILS
          if (
            typeof this.candidateData.influencerDetails.instagramId !==
            "undefined"
          ) {
            this.influencerFirstName = this.candidateData.influencerDetails.firstName;
            this.influencerLastName = this.candidateData.influencerDetails.lastName;
            this.influencerAddr1 = this.candidateData.influencerDetails.address1;
            this.influencerAddr2 = this.candidateData.influencerDetails.address2;
            this.influencerState = this.candidateData.influencerDetails.addressState;
            this.influencerCountry = this.candidateData.influencerDetails.addressCountry;
            this.influencerZip = this.candidateData.influencerDetails.addressZipcode;
            this.influencerCity = this.candidateData.influencerDetails.addressCity;
            try {
              this.selectedTags = this.candidateData.influencerDetails.tags.map(
                x => {
                  return { key: x, value: x };
                }
              );
            } catch (err) {
              console.log("NO TAGS FOUND", err);
            }
          }
        }
      } catch (err) {}
    },
    async showNoteModal() {
      try {
        this.noteFormAlert = false;
        this.addNoteModal = true;
        this.$refs.noteForm.reset();
      } catch (err) {}
    },
    async closeNoteModal() {
      try {
        this.addNoteModal = false;
        this.$refs.noteForm.reset();
        this.noteFormAlertMsg = "";
        this.noteFormAlert = true;
      } catch (err) {}
    },
    async showEditNoteModal(noteData) {
      try {
        console.log(noteData);
        this.noteFormAlert = false;
        this.editNoteModal = true;
        this.editNoteText = noteData.text;
        this.editNoteType = noteData.type;
        this.editNoteId = noteData._id;
        this.editVisibilityType = noteData.visibility;
        if (noteData.visibility === "all") {
          this.editVisibilityType = "team and client";
        }
      } catch (err) {}
    },
    async closeEditNoteModal() {
      try {
        this.editNoteModal = false;
        this.$refs.editNoteForm.reset();
        this.editNoteFormAlertMsg = "";
        this.editNoteFormAlert = true;
      } catch (err) {}
    },
    async showArchiveNoteConfirm(noteId) {
      try {
        console.log(noteId);
        this.archiveNoteConfirm = true;
        this.archiveNoteId = noteId;
      } catch (err) {}
    },
    async closeArchiveNoteConfirm() {
      try {
        this.archiveNoteConfirm = false;
        this.archiveNoteId = null;
      } catch (err) {}
    },
    async showArchiveCandidateModal() {
      try {
        this.archiveCandidateModal = true;
      } catch (err) {}
    },
    async closeArchiveCandidateModal() {
      try {
        this.archiveCandidateModal = false;
      } catch (err) {}
    },
    async submitNote(e) {
      e.preventDefault();

      try {
        let self = this;
        if (self.$refs.noteForm.validate()) {
          console.log("NEW NOTE:", this.newNote);
          let newNote = {};
          newNote.text = this.newNoteText;
          newNote.visibility = this.visibilityType;
          if (this.visibilityType === "team and client") {
            newNote.visibility = "all";
          }

          newNote.type = this.noteType;
          newNote.usertoken = this.auth;
          newNote.candidate = this.$route.params.candidateId;
          console.log("HERE IS THE NEW NOTE:", newNote);

          // SUBMIT NOTE
          let newNoteResponse = await axios.post(
            influencerCandidateNoteCreateApi,
            newNote
          );
          console.log("HERES THE RESPONSE:", newNoteResponse.data);
          if (newNoteResponse.data.success === true) {
            console.log("NEW NOTE CREATED");
            this.closeNoteModal();
            this.loadingOverlayText = "Saving Note...";
            this.loadCandidate();
            window.scrollTo(0, document.body.scrollHeight);
            return;
          }

          console.log("NOTE FAILED");
          self.alertType = "error";
          self.noteFormAlertMsg = "Note creation failed.";
          self.noteFormAlert = true;

          // IF FAILED KEEP OPEN
        } else {
          console.log("VALIDATE FAILED");
          self.alertType = "error";
          self.noteFormAlertMsg = "Please check all fields.";
          self.noteFormAlert = true;
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR", err);

        self.alertType = "error";
        self.noteFormAlertMsg = "Please check all fields.";
        self.noteFormAlert = true;
      }
    },
    async submitEditNote(e) {
      e.preventDefault();

      try {
        let self = this;
        if (self.$refs.editNoteForm.validate()) {
          let updateNote = {};
          updateNote.text = this.editNoteText;
          updateNote.visibility = this.editVisibilityType;
          if (this.editVisibilityType === "team and client") {
            updateNote.visibility = "all";
          }
          updateNote.id = this.editNoteId;
          updateNote.type = this.editNoteType;
          updateNote.usertoken = this.auth;
          console.log("HERE IS THE NEW NOTE:", updateNote);

          // SUBMIT NOTE
          let updateNoteResponse = await axios.post(
            influencerCandidateNoteUpdateApi,
            updateNote
          );
          console.log("HERES THE RESPONSE:", updateNoteResponse.data);
          if (updateNoteResponse.data.success === true) {
            console.log("NEW NOTE CREATED");
            this.closeEditNoteModal();
            this.loadingOverlayText = "Saving Note...";
            this.loadCandidate();
            window.scrollTo(0, document.body.scrollHeight);
            return;
          }

          console.log("NOTE FAILED");
          self.alertType = "error";
          self.noteFormAlertMsg = "Note creation failed.";
          self.noteFormAlert = true;

          // IF FAILED KEEP OPEN
        } else {
          console.log("VALIDATE FAILED");
          self.alertType = "error";
          self.noteFormAlertMsg = "Please check all fields.";
          self.noteFormAlert = true;
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR", err);

        self.alertType = "error";
        self.noteFormAlertMsg = "Please check all fields.";
        self.noteFormAlert = true;
      }
    },
    async submitArchiveNote() {
      try {
        let archiveNote = {};
        archiveNote.id = this.archiveNoteId;
        archiveNote.usertoken = this.auth;
        console.log("HERE IS THE NEW NOTE:", archiveNote);

        this.archiveNoteConfirm = false;
        this.loadingOverlayText = "Archiving Note...";

        // SUBMIT NOTE
        let archiveNoteResponse = await axios.post(
          influencerCandidateNoteArchiveApi,
          archiveNote
        );
        console.log("HERES THE RESPONSE:", archiveNoteResponse.data);
        if (archiveNoteResponse.data.success === true) {
          this.archiveNoteId = null;
          this.loadCandidate();
          window.scrollTo(0, document.body.scrollHeight);
          return;
        }
        console.log("NOTE FAILED");
        self.alertType = "error";
        self.alertMsg = "Note archive failed.";
        self.displayAlert = true;
        window.scrollTo(0, 0);

        // IF FAILED KEEP OPEN
      } catch (err) {
        console.log("THERE WAS AN ERROR", err);
        self.alertType = "error";
        self.alertMsg = "Could not archive note.";
        self.displayAlert = true;
        window.scrollTo(0, 0);
      }
    },
    async submitArchiveCandidate() {
      try {
        let archiveCandidate = {};
        archiveCandidate.candidate = this.candidateId;
        archiveCandidate.usertoken = this.auth;
        archiveCandidate.status = "archived";

        this.archiveCandidateModal = false;
        this.loadingOverlayText = "Deleting Candidate...";

        // SUBMIT NOTE
        let archiveCandidateResponse = await axios.post(
          influencerCandidateUpdateStatusApi,
          archiveCandidate
        );
        console.log("HERES THE RESPONSE:", archiveCandidateResponse.data);
        if (archiveCandidateResponse.data.success === true) {
          this.$router.push(
            `/influencer-campaign/manage/${this.candidateData.campaign.campaignId}`
          );
        }
        console.log("CANDIDATE  FAILED");
        self.alertType = "error";
        self.alertMsg = "Could not archive candidate.";
        self.displayAlert = true;
        window.scrollTo(0, 0);

        // IF FAILED KEEP OPEN
      } catch (err) {
        console.log("THERE WAS AN ERROR", err);
        self.alertType = "error";
        self.alertMsg = "Could not archive Candidate.";
        self.displayAlert = true;
        window.scrollTo(0, 0);
      }
    },
    async submitInfluencerDetails() {
      this.editInfluencerDetailsModal = false;
      let influencerUpdate = {};
      influencerUpdate.usertoken = this.auth;
      influencerUpdate.firstName = this.influencerFirstName;
      influencerUpdate.lastName = this.influencerLastName;
      influencerUpdate.city = this.influencerCity;
      influencerUpdate.zip = this.influencerZip;
      influencerUpdate.state = this.influencerState;
      influencerUpdate.country = this.influencerCountry;
      influencerUpdate.address1 = this.influencerAddr1;
      influencerUpdate.address2 = this.influencerAddr2;
      influencerUpdate.email = this.influencerEmail;
      influencerUpdate.phone = this.influencerPhone;
      influencerUpdate.instagramId = this.candidateData.instagramId;

      let influencerUpdateResponse = await axios.post(
        influencerUpdateApi,
        influencerUpdate
      );
      console.log("UPDATE INFLUENCER RESPONSE:", influencerUpdateResponse);
      if (influencerUpdateResponse.data.success === true) {
        this.loadCandidate();
      }
    },
    async tagSearch(value) {
      if (this.tagSearchActive === false) {
        if (value.length > 3) {
          this.tagSearchActive = true;
          //console.log("HERE IS THE TAG:", value);

          let tagSearchResponse = await axios.get(
            `${influencerTagSearchApi}/?usertoken=${this.auth}&tag=${value}`
          );
          //console.log("HERE IS THE SEARCH RESULT:", tagSearchResponse.data);
          this.tagSearchActive = false;
          if (tagSearchResponse.data.success === true) {
            let tagList = tagSearchResponse.data.result.map(x => {
              return { value: x.name, key: x.name };
            });
            this.tagList = tagList;

            console.log();
          }
        }
      }
    },
    async tagAdd(tag) {
      //console.log("HELLO WORLD ADDED TAG");
      //console.log("VALUE ADDED:", tag);
      //console.log("CHECK TAG RESULT:", this.candidateData.influencerDetails.tags.indexOf(tag.value) )
      console.log("CHECKING TAGS: ", this.candidateData.influencerDetails.tags);
      if (typeof this.candidateData.influencerDetails.tags === "undefined") {
        let newTag = {};
        newTag.tag = tag.value;
        newTag.usertoken = this.auth;
        newTag.instagramId = this.candidateData.instagramId;
        //console.log("SENDING THIS TAG:", newTag);
        let tagAddResponse = await axios.post(influencerTagAddApi, newTag);

        return;
      }
      if (this.candidateData.influencerDetails.tags.indexOf(tag.value) === -1) {
        let newTag = {};
        newTag.tag = tag.value;
        newTag.usertoken = this.auth;
        newTag.instagramId = this.candidateData.instagramId;
        //console.log("SENDING THIS TAG:", newTag);
        let tagAddResponse = await axios.post(influencerTagAddApi, newTag);
        // console.log("HERE IS THE ADD RESULT:", tagAddResponse.data);
        return;
      }
    },
    async tagRemove() {
      //console.log("HELLO WORLD REMOVED TAG");

      let tagUpdate = this.selectedTags.map(x => {
        return x.value.toLowerCase();
      });
      let newTag = {};
      newTag.tags = tagUpdate;
      newTag.usertoken = this.auth;
      newTag.instagramId = this.candidateData.instagramId;

      // console.log("LATEST TAGS:", tagUpdate);
      let tagUpdateResponse = await axios.post(influencerTagUpdateApi, newTag);
      //console.log("HERE IS THE SEARCH RESULT:", tagAddResponse.data
    },
    async showEventConfirmModal(event) {
      console.log("GOT EVENT:", event);
      this.activeEvent = event;
      this.eventModalLabel = event.eventData.inputLabel;
      this.eventConfirmModal = true;
    },
    async showEventSelectModal(event) {
      try {
        console.log("GOT EVENT:", event);
        this.activeEvent = event;
        this.eventSelectOptions = event.eventData.options;
        this.eventModalLabel = event.eventData.inputLabel;
        this.eventSelectModal = true;
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async closeEventSelectModal() {
      this.activeEvent = null;
      this.eventSelectOptions = null;
      this.eventModalLabel = null;
      this.eventSelectModal = false;
    },
    async closeEventConfirmModal() {
      this.activeEvent = null;
      this.eventSelectOptions = null;
      this.eventModalLabel = null;
      this.eventConfirmModal = false;
    },
    async showEventInputModal() {},
    async closeEventInputModal() {
      this.activeEvent = null;
    },
    async processEvent() {
      console.log("HERE IS THE EVENT", this.activeEvent);
      if (this.activeEvent.eventData.type === "select") {
        if (this.eventSelectInput !== null) {
          let eventUpdate = {};
          eventUpdate.eventId = this.activeEvent._id;
          eventUpdate.eventInput = this.eventSelectInput;
          eventUpdate.eventStatus = "complete";
          eventUpdate.candidate = this.activeEvent.candidateId;
          eventUpdate.usertoken = this.auth;
          if (this.eventNote !== null) {
            eventUpdate.note = this.eventNote;
          }
          if (this.activeEvent.eventData.endSequence === "true") {
            if (
              this.activeEvent.eventData.endSequenceInput ===
              this.eventSelectInput
            ) {
              eventUpdate.influencerStatus = this.activeEvent.eventData.endSequenceInfluencerStatus;
              eventUpdate.sequenceEnd = true;
            }
          }
          console.log("EVENT UPDATE:", eventUpdate);
          this.eventSelectModal = false;
          let influencerUpdateEventResponse = await axios.post(
            influencerEventUpdateApi,
            eventUpdate
          );
          console.log("HERE IS THE RESPONSE: ", influencerUpdateEventResponse);
          if (influencerUpdateEventResponse.data.success === true) {
            this.activeEvent = null;
            this.eventSelectOptions = null;
            this.eventModalLabel = null;
            await this.loadCandidate();
          }
        }

        // RETURN ERROR
      }
      if (this.activeEvent.eventData.type === "confirmation") {
        let eventUpdate = {};
        eventUpdate.eventId = this.activeEvent._id;
        eventUpdate.eventInput = "yes";
        eventUpdate.eventStatus = "complete";
        eventUpdate.candidate = this.activeEvent.candidateId;
        eventUpdate.usertoken = this.auth;
        if (this.eventNote !== null) {
          eventUpdate.note = this.eventNote;
        }
        if (this.activeEvent.eventData.endSequence === "true") {
          if (
            this.activeEvent.eventData.endSequenceInput ===
            this.eventSelectInput
          ) {
            eventUpdate.influencerStatus = this.activeEvent.eventData.endSequenceInfluencerStatus;
            eventUpdate.sequenceEnd = true;
          }
        }
        console.log("EVENT UPDATE:", eventUpdate);
        this.eventConfirmModal = false;
        let influencerUpdateEventResponse = await axios.post(
          influencerEventUpdateApi,
          eventUpdate
        );
        console.log("HERE IS THE RESPONSE: ", influencerUpdateEventResponse);
        if (influencerUpdateEventResponse.data.success === true) {
          this.activeEvent = null;
          this.eventSelectOptions = null;
          this.eventModalLabel = null;
          await this.loadCandidate();
        }

        // RETURN ERROR
      }
    },
    noteTypeCheck(event) {
      //console.log(event);
      if (event === null || typeof event === "undefined") {
        return "Select note type.";
      }
      return true;
    },
    noteVisibilityCheck(event) {
      //console.log(event);
      if (event === null || typeof event === "undefined") {
        return "Select note visibility.";
      }
      return true;
    }
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadingOverlayText = "Loading...";
    this.candidateId = this.$route.params.candidateId;
    this.loadCandidate();
  }
};
</script>

<style scoped>
.profile-label {
  text-align: right;
}
.status-complete {
  background-color: green;
  color: white;
}
.note-date {
  font-size: 10px;
  color: gray;
}
@import "https://cdn.jsdelivr.net/npm/@voerro/vue-tagsinput@2.0.2/dist/style.css";
</style>